CCL.footer = {
  autoload: [
    ['funBrowserDropdown', $('.fun-browser .mdropdown').length > 0]
  ],
  funBrowserDropdown() {
    $('.fun-browser .mdropdown').click((e) => {
      e.preventDefault();
      const parent = $('.mdropdown-menu');
      const expand = $(e.currentTarget).attr('aria-expanded');
      if ($(window).width() < 768) {
        $(parent).slideToggle();
        $(e.currentTarget).toggleClass('show');
      }
      if (expand === 'false') {
        $(e.currentTarget).attr('aria-expanded', 'true');
      } else {
        $(e.currentTarget).attr('aria-expanded', 'false');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-bgo-footer/bgo-footer.js